import React, { useEffect, useId, useReducer } from "react";
import ReactDOM from "react-dom";
import { Backdrop, CircularProgress, styled } from "@mui/material";

type Props = {
    open: boolean,
    main?: boolean,
    children?: JSX.Element | JSX.Element[]
}

const pool: string[] = [];

export function LoadingBackDrop(props: Props): JSX.Element | null {
    const id = useId();
    const [, forceUpdate] = useReducer((x: number) => x + 1, 0);

    useEffect(() => {
        if (!props.main && props.open) {
            pool.push(id);
            const event = new CustomEvent('beach-backdrop-change');
            document.dispatchEvent(event);
            return () => {
                const index = pool.indexOf(id);
                if (index >= 0) {
                    pool.splice(index, 1);
                    const event = new CustomEvent('beach-backdrop-change');
                    document.dispatchEvent(event);
                }
            };
        }
    }, [props.main, props.open]);

    useEffect(() => {
        if (props.main) {
            const handler = () => {
                forceUpdate();
            }
            document.addEventListener('beach-backdrop-change', handler);
            return () => document.removeEventListener('beach-backdrop-change', handler);
        }
    }, [props.main]);

    if (!props.main || pool.length === 0) {
        return null;
    }

    const app = document.getElementById("app");
    if (app) {
        return ReactDOM.createPortal(
            <CustomBackdrop
                open
                onClick={(event) => event.stopPropagation()}
            >
                {props.children ?? <CircularProgress />}
            </CustomBackdrop>,
            app
        );
    }
    return null;
}

const CustomBackdrop = styled(Backdrop)(({ theme }) => ({
    "zIndex": theme.zIndex.tooltip + 2,
    '& *': {
        color: '#E6592F'
    }
}));
